import GroupingSelectorWithDetailsLevel from './GroupingSelectorWithDetailsLevel'
import {ReportGroupingLevel} from './constants'
import messageResource from '../messageResource'
import _ from 'underscore'

export default function ThreeLevelReportGroupingSelector() {
    this.constructor = ThreeLevelReportGroupingSelector;
}

ThreeLevelReportGroupingSelector.prototype = _.create(GroupingSelectorWithDetailsLevel.prototype);

ThreeLevelReportGroupingSelector.prototype.init = function(config)
{
    this.enableNoneFirstGrouping = config.enableNoneFirstGrouping;
    this.enableGroupByBillingType = config.enableGroupByBillingType;
    this.enableGroupByUsers = config.enableGroupByUsers;
    this.enableGroupByUserGroups = config.enableGroupByUserGroups;
    this.enableGroupByTimeZoneGroups =  config.enableGroupByTimeZoneGroups;

    if (config.includeTTCommentsInDetailsLevel)
    {
        this.detailsLevelTaskGroupingTypes = [ReportGroupingLevel.TASK, ReportGroupingLevel.TT_COMMENTS, ReportGroupingLevel.TASK_AND_TT_COMMENTS];
        this.detailsLevelProjectGroupingTypes = [ReportGroupingLevel.PROJECT, ReportGroupingLevel.TT_COMMENTS, ReportGroupingLevel.PROJECT_AND_TT_COMMENTS];
        this.detailsLevelCustomerGroupingTypes = [ReportGroupingLevel.CUSTOMER, ReportGroupingLevel.TT_COMMENTS, ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS];
    }
    else
    {
        this.detailsLevelTaskGroupingTypes = [ReportGroupingLevel.TASK];
        this.detailsLevelProjectGroupingTypes = [ReportGroupingLevel.PROJECT];
        this.detailsLevelCustomerGroupingTypes = [ReportGroupingLevel.CUSTOMER];
    }

    GroupingSelectorWithDetailsLevel.prototype.init.call(this, config.selectorId, 2, config.groupingLevelsSelection, config.changesCallback);

    this.showRow(2);

    return this;
};

ThreeLevelReportGroupingSelector.prototype.fillListSelector = function(listSelector, level)
{
    if (level === 0 || level === 1)
    {
        if( level === 1 || this.enableNoneFirstGrouping )
        {
            const itemTextKey = level === 0 ? "report.form.dont_use_1st_grouping_level" : "report.form.dont_use_2nd_grouping_level";
            listSelector.addItems( [{
                                        text: messageResource.getMessage( itemTextKey ),
                                        value: ReportGroupingLevel.NONE
                                    }] );
            listSelector.addSeparator();
        }
        listSelector.addItems( [{
                                    text: messageResource.getEscapedMessage( "common.Customers" ),
                                    value: ReportGroupingLevel.CUSTOMER
                                },
                               {
                                    text: messageResource.getEscapedMessage( "common.Projects" ),
                                    value: ReportGroupingLevel.PROJECT
                                },
                               {
                                    text: messageResource.getEscapedMessage( "report.form.projects_joined_by_name" ),
                                    value: ReportGroupingLevel.PROJECT_NAME
                                },
                               {
                                    text: messageResource.getEscapedMessage( "report.form.tasks_joined_by_name" ),
                                    value: ReportGroupingLevel.TASK_NAME
                                }]
        );
        if( this.enableGroupByBillingType )
        {
            listSelector.addItems( [{
                                        text: messageResource.getMessage( "report.common.billing_types" ),
                                        value: ReportGroupingLevel.BILLING_TYPE
                                    }] );
        }
        listSelector.addSeparator();
        if (this.enableGroupByUsers) {
            listSelector.addItems( [{
                                        text: messageResource.getMessage( "report.common.users" ),
                                        value: ReportGroupingLevel.USER
                                    }] );
        }
        if (this.enableGroupByUserGroups) {
            listSelector.addItems( [{
                                        text: messageResource.getEscapedMessage( "common.User_Groups" ),
                                        value: ReportGroupingLevel.USER_GROUP
                                    }] );
        }
        if (this.enableGroupByTimeZoneGroups) {
            listSelector.addItems( [{
                text: messageResource.getEscapedMessage( "common.Time_Zone_Groups" ),
                value: ReportGroupingLevel.TIME_ZONE_GROUP
            }] );
        }
        if (this.enableGroupByUsers || this.enableGroupByUserGroups || this.enableGroupByTimeZoneGroups) {
            listSelector.addSeparator();
        }
        listSelector.addItems( [{
                                    text: messageResource.getMessage( "report.common.dates" ),
                                    value: ReportGroupingLevel.DATE
                                },
                               {
                                    text: messageResource.getMessage( "report.common.weeks" ),
                                    value: ReportGroupingLevel.WEEK
                                },
                               {
                                    text: messageResource.getMessage( "report.common.months" ),
                                    value: ReportGroupingLevel.MONTH
                                }]
        );
    }
    else
    {
        listSelector.addItems( [{
                                    text: messageResource.getMessage( "report.hide_details" ),
                                    value: ReportGroupingLevel.NONE
                                },
                               {
                                    text: messageResource.getEscapedMessage( "common.Customers" ),
                                    value: ReportGroupingLevel.CUSTOMER
                                },
                               {
                                    text: messageResource.getEscapedMessage( "common.Projects" ),
                                    value: ReportGroupingLevel.PROJECT
                                },
                               {
                                    text: messageResource.getEscapedMessage( "common.Tasks" ),
                                    value: ReportGroupingLevel.TASK
                                },
                               {
                                    text: messageResource.getMessage( "report.tt_comments" ),
                                    value: ReportGroupingLevel.TT_COMMENTS
                                },
                               {
                                    text: messageResource.getEscapedMessage( "report.tasks.and_tt_comments" ),
                                    value: ReportGroupingLevel.TASK_AND_TT_COMMENTS
                                },
                               {
                                    text: messageResource.getEscapedMessage( "report.projects.and_tt_comments" ),
                                    value: ReportGroupingLevel.PROJECT_AND_TT_COMMENTS
                                },
                               {
                                    text: messageResource.getEscapedMessage( "report.customers.and_tt_comments" ),
                                    value: ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS
                                }]
        );
    }
};

ThreeLevelReportGroupingSelector.prototype.validate = function()
{
   if (!GroupingSelectorWithDetailsLevel.prototype.validate.call(this))
        return false;

   return this.verifyDateGroupingOrderFroTwoLevels();
};

ThreeLevelReportGroupingSelector.prototype.isProjectGroupingLevel = function(groupingLevel)
{
    return groupingLevel === ReportGroupingLevel.PROJECT || groupingLevel === ReportGroupingLevel.PROJECT_NAME;
};

ThreeLevelReportGroupingSelector.prototype.isTaskGroupingLevel = function(groupingLevel)
{
    return groupingLevel === ReportGroupingLevel.TASK_NAME;
};

ThreeLevelReportGroupingSelector.prototype.getDetailsGroupingSelection = function(allowedDetails, detailsGrouping)
{
    let changeSelectionTo = [];
    if( detailsGrouping === ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS )
        changeSelectionTo = [ReportGroupingLevel.PROJECT_AND_TT_COMMENTS, ReportGroupingLevel.TASK_AND_TT_COMMENTS];
    if( detailsGrouping === ReportGroupingLevel.PROJECT_AND_TT_COMMENTS)
        changeSelectionTo = [ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS, ReportGroupingLevel.TASK_AND_TT_COMMENTS];
    if( detailsGrouping === ReportGroupingLevel.TASK_AND_TT_COMMENTS )
        changeSelectionTo = [ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS, ReportGroupingLevel.PROJECT_AND_TT_COMMENTS];

    for( let i = 0; i < changeSelectionTo.length; i++ )
    {
        if(allowedDetails.includes(changeSelectionTo[i]))
            return changeSelectionTo[i];
    }
    return allowedDetails[0];
};

ThreeLevelReportGroupingSelector.prototype.updateDetailsOptions = function()
{
    const firstGrouping = this.getListSelectorValue(0);
    const secondGrouping = this.getListSelectorValue(1);
    const detailsGrouping = this.getDetailsListSelectorValue();

    let allowedDetails = [];

    if (this.isTaskGroupingLevel(firstGrouping) || this.isTaskGroupingLevel(secondGrouping))
    {
        if (this.isProjectGroupingLevel(firstGrouping) || this.isProjectGroupingLevel(secondGrouping))
            allowedDetails = this.detailsLevelCustomerGroupingTypes.slice();
        else
            allowedDetails = this.detailsLevelProjectGroupingTypes.slice();
    }
    else
        allowedDetails = this.detailsLevelTaskGroupingTypes.slice();

    if (!(firstGrouping === ReportGroupingLevel.NONE && secondGrouping === ReportGroupingLevel.NONE))
        allowedDetails.push( ReportGroupingLevel.NONE );

    this.detailsListSelector.menu.items.each(
            function(item)
            {
                if (allowedDetails.includes(item.value))
                    item.show();
                else
                    item.hide();
            } );

    const itemToSelect = allowedDetails.includes(detailsGrouping) ?
                       detailsGrouping : this.getDetailsGroupingSelection( allowedDetails, detailsGrouping );

    this.detailsListSelector.setActiveItemByValue(itemToSelect);
};

ThreeLevelReportGroupingSelector.prototype.updateTree = function()
{
    const firstShown = this.getListSelectorValue(0) !== ReportGroupingLevel.NONE;
    const secondShown = this.getListSelectorValue(1) !== ReportGroupingLevel.NONE;
    const detailsShown = this.getDetailsListSelectorValue() !== ReportGroupingLevel.NONE;

    if(firstShown)
    {
        this.setRowClassName(0, "");
        this.setRowClassName(1, secondShown ? "tree-row-A" : detailsShown ? "tree-row-J" : "tree-row-I");
        this.setRowClassName(2, detailsShown ? secondShown ? "tree-row-SA" : "tree-row-AL" : "tree-row-SI");
    }
    else
    {
        this.setRowClassName(0, "tree-row-I");
        this.setRowClassName(1, secondShown ? "tree-row-AI" : "tree-row-I");
        this.setRowClassName(2, detailsShown ? secondShown ? "tree-row-SA" : "tree-row-SAI" : "tree-row-SI");
    }
};




// WEBPACK FOOTER //
// ./web/js/reports/ThreeLevelReportGroupingSelector.js